import React from 'react'
import {Nav} from 'react-bootstrap';
import '../styles/footer.css';
import '../styles/app.css'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Marquee from "react-fast-marquee";

function Footer(){
    return(
        <div className="footer_wrapper"> 
        <div className="clients_container page_content">
            <div className="title">
                <h5>Trusted By:</h5>
            </div>
            
            <Marquee speed="80">             
                <div className="brand"><img src="../../assets/brands/axiz.png" alt="noimage"/></div>                
                <div className="brand"><img src="../../assets/brands/istore.png" alt="noimage"/></div>
                <div className="brand"><img src="../../assets/brands/linqage.png" alt="noimage"/></div>
                <div className="brand"><img src="../../assets/brands/mastek.png" alt="noimage"/></div>
                <div className="brand"><img src="../../assets/brands/pinnacle.png" alt="noimage"/></div>
                <div className="brand"><img src="../../assets/brands/rectron.png" alt="noimage"/></div>
                <div className="brand"><img src="../../assets/brands/tarsus.png" alt="noimage"/></div>
            </Marquee>
        </div>
        <div className="footer_container page_content grey_bg">
            <div className="container">
                <div className="row">
                    <div className=" col-md-5">
                    <span className="footer_heading">Contact Us</span>
                        <div className="contact_group">
                            <div className="icon">                           

                            <FontAwesomeIcon icon="home" />
                            </div>
                            <div className="detail">
                                <span className="title">Head Office</span>
                                <span>369 Panaroma Road</span>
                                <span>Woodwind Estate</span>
                                <span>59 Oboni Park</span>
                                <span>Centurion 0066</span>
                            </div>
                        </div>

                        <div className="contact_group">
                            <div className="icon">
                                <FontAwesomeIcon icon="phone" />
                            </div>
                            <div className="detail">
                                <span className="title">Region: Johannesburg</span>
                                <span>081 4726 345 / 062 2429 228</span>                               
                            </div>
                        </div>

                        <div className="contact_group">
                            <div className="icon">
                                <FontAwesomeIcon icon="envelope-open-text" />
                            </div>
                            <div className="detail">
                                <span className="title"><a href="mailto:info@smartks.co.za">info@smartks.co.za</a> </span>                                                             
                            </div>
                        </div>
                    </div>
                    <div className="links col-md-3">
                        <span className="footer_heading">Links</span>
                        <ul>
                        <Nav.Link href="/contact-us">Contact Us</Nav.Link>
                        <Nav.Link href="/about">About Us</Nav.Link>
                        <Nav.Link href="/services">Services</Nav.Link>
                        <Nav.Link href="/home">Home</Nav.Link>
                        </ul>
                    </div>
                    <div className=" col-md-4">
                        <div className="logo">
                        <img src="../../assets/logo-full.jpg" alt="logo"/>  
                        </div>
                                              
                    </div>
                </div>
            </div>
            <small className="powered_by">Powered by ANT Solutions</small>
        </div>
        </div>
    );
}

export default Footer;